import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	contextNotApplied: {
		id: 'project-settings-product-features-jsm-tmp.restricted-field-warnings.context-not-applied',
		defaultMessage:
			"You can't see this field in the issue view as the context is not applied to this project. <a>Add or edit context</a> to add a global context for this field. <link>Learn about the global context and your project</link>",
		description:
			'Warning text when field context is set, when there is no context at all or the context is for different project',
	},
	contextNotAppliedIssueTermRefresh: {
		id: 'project-settings-product-features-jsm-tmp.restricted-field-warnings.context-not-applied-issue-term-refresh',
		defaultMessage:
			"You can't see this field in the work item view as the context is not applied to this project. <a>Add or edit context</a> to add a global context for this field. <link>Read about the global context and your project</link>",
		description:
			'Warning text when field context is set, when there is no context at all or the context is for different project',
	},
});
